<template>
    <el-dialog :title="type === 'feedback' ? '反馈作业' : '编辑反馈'" width="860px" center :close-on-click-modal="false"
        :visible="isShowFeedbackDialog" @close="closeFeedback">
        <div class="work-reminder">
            <header>{{ feedback_title }}</header>
            <span>{{ feedback_content }}</span>
        </div>
        <div class="work-contanier">
            <div class="work-txt">
                <el-input ref="content" type="textarea" resize="none" class="work-content" maxlength="1000" :rows="12"
                    show-word-limit v-model="content" placeholder="请填写完成作业..." />
                <text class="work-txt-length">{{ content.length }}/1000</text>
            </div>
            <upload-file :hasphotos="photos" :hasthumb="thumb_photos" :voice="audio" @addSource="addSource"></upload-file>
        </div>

        <div slot="footer">
            <el-button plain @click="closeFeedback">取消</el-button>
            <el-button type="primary" @click="saveFeedback">完成</el-button>
        </div>
    </el-dialog>
</template>

<script>
import UploadFile from '../UploadFile.vue'
export default {
    components: { UploadFile },
    data () {
        return {
            content: '',
            audio: '',
            photos: [],
            thumb_photos: []
        }
    },
    props: {
        isShowFeedbackDialog: {
            type: Boolean,
            default: false
        },
        feedback_title: {
            type: String,
            default: ''
        },
        feedback_content: {
            type: String,
            default: ''
        },
        feedback_data: [Object],
        type: {
            type: String,
            default: 'feedback'
        },
        work_id: [Number, String]
    },

    mounted () {
        if (this.type === 'edit_feedback') {
            this.photos = this.feedback_data.images
            this.thumb_photos = this.feedback_data.thumbs
            this.audio = this.feedback_data.voice
            this.content = this.feedback_data.content
        }
    },

    methods: {
        closeFeedback () {
            this.$emit('closeFeedback')
        },

        // 添加资源
        addSource (data) {
            const file = data
            if (file.type === 'img') {
                const { thumb_photos, photos } = file
                this.thumb_photos = thumb_photos
                this.photos = photos
            } else {
                const { audio } = file
                this.audio = audio
                this.isShowAudioPlayer = true
            }
        },

        async saveFeedback () {
            if (!this.content) {
                this.$message.warning('请输入作业内容')
                this.$refs.content.focus()
                return
            }

            let data = {
                title: this.feedback_title,
                content: this.content,
                images: this.photos.join(','),
                thumbs: this.thumb_photos.join(','),
                voice_length: 0,
                voice_play_length: 0,
                voice: this.audio,
            }


            if (this.type === 'feedback') {
                const type1 = { work_id: this.work_id }
                data = { ...data, ...type1 }
            } else {
                const type2 = { feedback_id: this.feedback_data.id }
                data = { ...data, ...type2 }
            }


            const url = this.type === 'feedback' ? 'base/homework/feedback/create' : 'base/homework/feedback/update'
            const { data: res } = await this.$axios.post(url, data)
            if (res.errCode === 0) {
                // console.log(res.data)
                this.$message.success("编辑成功")
                if (this.type === 'feedback') {
                    this.$store.dispatch('setHouseworkStatus', true)
                }
                this.$emit('updateHousework')
            } else {
                this.$message.error(res.message)
            }
        },

    }
}
</script>

<style lang="scss" scoped>
@import '../../../../../assets/css/housework.scss';

.work-reminder {
    padding: 20px 16px;
    box-sizing: border-box;
    background: #F5F7F8;

    header {

        font-size: 18px;
        font-weight: bold;
        color: #3B4043;
    }

    span {
        display: inline-block;
        margin-top: 10px;
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        color: #62666A;
    }
}
</style>


// WEBPACK FOOTER //
// src/view/Panel/housework/components/student/FeedbackDiolag.vue